export default __webpack_public_path__ + "static/stone-style-1-5e564b6c60980047c15a3dc815c9ca53.png";